import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "environments/environment";
import { catchError, map } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";

@Injectable({
  providedIn: "root",
})
export class CompanyConfigService {
  private url = `${environment.apiUrl}/private/companies/config`;

  constructor(
    private _http: HttpClient,
    private readonly _toastr: ToastrService
  ) {}

  setCompanyConfig = (
    companyId: number,
    config: CompanyConfigPartial
  ): Observable<any> =>
    this._http.post(`${this.url}/create/${companyId}`, config).pipe(
      map((res) => {
        this._toastr.success("Configuración establecida");
        return res;
      }),
      catchError((error) => {
        console.error("Error al establecer config de cliente", error);
        this._toastr.error("Ocurrio un error al establecer configuración");
        throw error;
      })
    );

  getList = (): Observable<any> => this._http.get(`${this.url}/list`);

  getCompanyConfig = (companyId: number): Observable<any> =>
    this._http.get(`${this.url}/company-config/${companyId}`).pipe(
      catchError((error) => {
        console.error("Error al obtener config de cliente", error);
        throw error;
      })
    );
}

export enum  COMPANY_CONFIG {
  MESSAGE_VISIBILITY = "messageVisibility",
  FAKE_SEND = "fakeSend",
  EMG_SEND = "emgSend",
  ALLOW_ALPHANUMERIC_IN_SMS_CONTENT = "allowAlphanumericInSMSContent",
  LIST_OF_ALPHANUMERICS_IN_SMS_CONTENT = "listOfAlphanumericsInSMSContent",
  DELIVERY_ROUTING = "allowDeliveryRouting",
  WHATSAPP_TEMPLATE_FALLBACK = "whatsappFallbackTemplateId",
  CUSTOM_SUPPORT_ENABLED = "customSupportEnabled",
  CUSTOM_SUPPORT_CONTENT = "customSupportContent",
  CUSTOM_SUPPORT_CHANNELS = "customSupportChannels",
  ENABLE_SENDER_MANAGEMENT = "enableSenderManagement",
}

export interface SupportChannel {
  type: 'email' | 'phone' | 'whatsapp' | 'website';
  label: string;
  value: string;
  schedule?: string;
  isActive: boolean;
}

export type CompanyConfig = {
  [COMPANY_CONFIG.MESSAGE_VISIBILITY]: boolean;
  [COMPANY_CONFIG.FAKE_SEND]: boolean;
  [COMPANY_CONFIG.EMG_SEND]: boolean;
  [COMPANY_CONFIG.ALLOW_ALPHANUMERIC_IN_SMS_CONTENT]: boolean;
  [COMPANY_CONFIG.LIST_OF_ALPHANUMERICS_IN_SMS_CONTENT]?: string[];
  [COMPANY_CONFIG.DELIVERY_ROUTING]: boolean;
  [COMPANY_CONFIG.WHATSAPP_TEMPLATE_FALLBACK]?: number;
  [COMPANY_CONFIG.CUSTOM_SUPPORT_ENABLED]?: boolean;
  [COMPANY_CONFIG.CUSTOM_SUPPORT_CONTENT]?: string;
  [COMPANY_CONFIG.CUSTOM_SUPPORT_CHANNELS]?: SupportChannel[];
  [COMPANY_CONFIG.ENABLE_SENDER_MANAGEMENT]?: boolean;
};

export type CompanyConfigPartial = Partial<CompanyConfig>;
